(function() {
  const THRESHOLD = 2500;

  function updateFreeShippingBar(cartTotal) {
    const remaining = THRESHOLD - cartTotal;
    const bars = document.querySelectorAll('.free-shipping-bar');
    if (!bars.length) return;

    bars.forEach(bar => {
      if (remaining > 0) {
        const percent = Math.min((cartTotal / THRESHOLD) * 100, 100);
        const formattedRemaining = (remaining / 100).toFixed(2).replace('.', ',') + ' €';
        bar.innerHTML = `
          <div class="free-shipping-progress">
            <p class="free-shipping-message">
              ¡Casi lo tienes! Solo <strong>${formattedRemaining}</strong> más para envío gratis 🎁
            </p>
            <div class="progress-bar-container">
              <div class="progress-bar-fill" style="width: ${percent}%"></div>
            </div>
          </div>`;
      } else {
        bar.innerHTML = `
          <div class="free-shipping-success">
            <p class="free-shipping-message">
              ✅ ¡Felicidades! Tienes <strong>ENVÍO GRATIS</strong>
            </p>
          </div>`;
      }
    });
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => updateFreeShippingBar(cart.total_price))
      .catch(() => {});
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, () => fetchCartAndUpdate());

  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
      const url = args[0];
      if (typeof url === 'string' && (url.includes('/cart/change') || url.includes('/cart/update'))) {
        response.clone().json().then(data => {
          if (data && data.total_price !== undefined) {
            updateFreeShippingBar(data.total_price);
          }
        }).catch(() => {});
      }
      return response;
    });
  };
})();
